import { Form, useForm } from '@/components/forms';
import Textarea from '@/components/forms/Textarea';
import { Upload } from '@/components/upload';
import { Label } from '@/design-system/label';
import { FileWithPreview } from '@/hooks/use-file-upload';
import { imageFileSchema } from '@/lib/uploadSchema';

import { z } from 'zod';

const pointRequestFormSchema = z.object({
  remarks: z.string().min(1, { message: 'Remarks is required' }),
  image: imageFileSchema,
});

export const PointRequestForm = () => {
  const form = useForm({ schema: pointRequestFormSchema, mode: 'onBlur' });
  const handleFilesChange = (files: FileWithPreview[]) => {
    if (files[0]?.file instanceof File) {
      form.setValue('image', files[0].file);
    } else {
      form.setValue('image', new File([], ''));
    }
  };
  return (
    <>
      <div className="flex justify-between mb-4 w-full py-3 px-6 bg-secondary absolute left-0 top-[20%]">
        <Label>※ このリクエストを承認してもよろしいですか？</Label>
      </div>
      <Form
        form={form}
        className="mt-15"
        onSubmit={() => {
          return new Promise((res) => {
            setTimeout(res, 5000);
          });
        }}
      >
        <div className="w-full flex flex-col gap-4.5">
          <Textarea label="pointManagement.page.form.managePoints.remarks" {...form.register('remarks')} />
          <Upload
            onFilesChange={handleFilesChange}
            label="pointManagement.page.form.managePoints.image"
            {...form.register('image')}
          />
        </div>
      </Form>
    </>
  );
};
